export default __webpack_public_path__ + "static/media/Silvia Contar_.3d874048.png";